import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import DemoApp from './App';

// Export MyComponent to make it accessible globally
window.DemoApp = DemoApp;

// Add a function to render the component
window.renderDemoApp = (containerId, props = {}) => {
  const root = ReactDOM.createRoot(document.getElementById(containerId));
  root.render(
    <DemoApp {...props} />
  );
};

const defaultRootId = 'demo-root';
const defaultRoot = document.getElementById(defaultRootId);
if (defaultRoot) {
  const hubspotPortalId = defaultRoot.dataset.hubspotPortalId;
  const hubspotFormId = defaultRoot.dataset.hubspotFormId;
  window.renderDemoApp(defaultRootId, {
    hubspotPortalId,
    hubspotFormId
  });
}